import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, NavController, } from '@ionic/angular';
import { ConfigService } from 'src/providers/config/config.service';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from 'src/providers/loading/loading.service';
import { SharedDataService } from 'src/providers/shared-data/shared-data.service';
import { AppEventsService } from 'src/providers/app-events/app-events.service';
import { EditAddressPage } from '../edit-address/edit-address.page';

@Component({
  selector: 'app-select-address',
  templateUrl: './select-address.page.html',
  styleUrls: ['./select-address.page.scss'],
})
export class SelectAddressPage implements OnInit {

  searchQuery: string = '';
  items;


  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: HttpClient,
    public appEventsService: AppEventsService,
    public config: ConfigService,
    public modalCtrl: ModalController,
    public loading: LoadingService,
    public shared: SharedDataService) {
    this.shared.currentOpenedModel = this;
    this.items = this.shared.allShippingAddress;

  }

  initializeItems() {
    this.items = this.shared.allShippingAddress;
  }

  getItems(ev: any) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (item.zone_name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }
  //close modal
  dismiss() {
     
    this.modalCtrl.dismiss({estado:'OK'});
    this.shared.currentOpenedModel = null;
  }

  selectAddress(value) {

    if (this.navParams.get('page') == 'shipping') {

      this.shared.orderDetails.tax_zone_id = value.zone_id;
      this.shared.orderDetails.delivery_firstname = value.firstname;
      this.shared.orderDetails.delivery_lastname = value.lastname;
      this.shared.orderDetails.delivery_state = value.state;
      this.shared.orderDetails.delivery_city = value.city;
      this.shared.orderDetails.delivery_postcode = value.postcode;
      this.shared.orderDetails.delivery_zone = value.zone_name;
      this.shared.orderDetails.delivery_country = value.country_name;
      this.shared.orderDetails.delivery_country_id = value.countries_id;
      this.shared.orderDetails.delivery_street_address = value.street;
      this.shared.orderDetails.delivery_lat = value.latitude;
      this.shared.orderDetails.delivery_lng = value.longitude;
      // if ($rootScope.zones.length == 0)
      if (value.zone_code == null) {
        this.shared.orderDetails.delivery_zone = 'other';
        this.shared.orderDetails.delivery_state = 'other';
        this.shared.orderDetails.tax_zone_id = null;
      }


    }
    else if (this.navParams.get('page') == 'editShipping') {

    }
    else {
      this.shared.orderDetails.billing_firstname = this.shared.orderDetails.delivery_firstname;
      this.shared.orderDetails.billing_lastname = this.shared.orderDetails.delivery_lastname;
      this.shared.orderDetails.billing_state = value.state;
      this.shared.orderDetails.billing_city = value.city;
      this.shared.orderDetails.billing_postcode = value.postcode;
      this.shared.orderDetails.billing_zone  = value.zone_name;
      this.shared.orderDetails.billing_country == value.country_name;
      this.shared.orderDetails.billing_country_id = value.countries_id;
      this.shared.orderDetails.billing_street_address =  value.street;
      this.shared.orderDetails.billing_phone =  this.shared.orderDetails.delivery_phone;
   
    }

    this.dismiss();
  }
  ngOnInit() {
  }

  
  async addShippingAddress() {
    let data = this.shared.customerData;
    let modal = await this.modalCtrl.create({
      component: EditAddressPage,
      componentProps: {data: data, type: 'add' }
    });
    modal.onDidDismiss().then(() => {
      this.getAllAddress();
    })
    return await modal.present();
  }

  getAllAddress() {
    this.loading.show();
    var dat = { customers_id: this.shared.customerData.customers_id };
    this.config.post_Http('getalladdress', dat)
      .subscribe(
        (data) => { // Success        
          this.loading.hide();
          if (data['resultado'].estado == 1) {
            this.shared.allShippingAddress = data['resultado'].data;
            this.items = this.shared.allShippingAddress;
          }
        },
        (error) => {
          this.loading.hide();
          this.shared.allShippingAddress = [];
          this.items = this.shared.allShippingAddress;
          console.error(error);
        });
  }
}
